angular.module('impactx.deliveryadvice').controller('DeliveryAdviceBuyerCtrl', [
    '$scope',
    'dataGen',
    '$controller',
    '$routeParams',
    DeliveryAdviceBuyerCtrl]);

function DeliveryAdviceBuyerCtrl($scope, dataGen, $controller, $routeParams) {
    angular.extend(this, $controller('DeliveryAdviceCtrl', {$scope: $scope}));
    var pohId = $routeParams.pohid;
    var self = this;
    if ($routeParams.avhid) {
        dataGen.getData($scope, {
            id: pohId,
            avhId: $routeParams.avhid
        }, "/deliveryadvice/viewbuyeravh").then(function () {
            $scope.headerSelection.selectedHeader = $scope.data.headers[0];
            self.updateLabels();
            self.defineButtons();
        });
    }
    else {
        dataGen.getData($scope, {id: pohId}, "/deliveryadvice/viewbuyer").then(function () {
            $scope.headerSelection.selectedHeader = $scope.data.headers[0];
            self.updateLabels();
            self.defineButtons();
        });
    }
}